import { useState, type FormEvent } from "react";
import { useAuth } from "@/context/AuthContext";

export default function ResetPasswordPage() {
  const { updatePassword, signOut } = useAuth();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState<{ text: string; ok: boolean } | null>(null);

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setMsg(null);
    if (password !== confirm) {
      setMsg({ text: "Las contraseñas no coinciden.", ok: false });
      return;
    }
    if (password.length < 6) {
      setMsg({
        text: "La contraseña debe tener al menos 6 caracteres.",
        ok: false,
      });
      return;
    }
    setLoading(true);
    const { error } = await updatePassword(password);
    setLoading(false);
    if (error) {
      setMsg({ text: error, ok: false });
    } else {
      setMsg({
        text: "¡Contraseña cambiada con éxito! Ahora ve al complemento en Excel e inicia sesión con tu nueva contraseña.",
        ok: true,
      });
      await signOut();
    }
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        background: "#fff",
      }}
    >
      <div className="login-container">
        <img src="/images/Excel-Logo.png" alt="Modo Imparable" />
        <h2>Nueva contraseña</h2>

        <form onSubmit={handleSubmit}>
          <input
            type="password"
            placeholder="Nueva contraseña"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            disabled={loading}
          />
          <input
            type="password"
            placeholder="Confirmar contraseña"
            value={confirm}
            onChange={(e) => setConfirm(e.target.value)}
            required
            disabled={loading}
          />
          <button type="submit" disabled={loading}>
            {loading ? "Actualizando..." : "Actualizar contraseña"}
          </button>
        </form>

        {msg && (
          <p className={msg.ok ? "reset-success-msg" : "error-msg"}>
            {msg.text}
          </p>
        )}
      </div>
    </div>
  );
}
